/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * logicomix-api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  MonetizationPatternAttributesApiDTO,
  MonetizationPatternCreateAttributesApiDTO
} from './Api.schemas'
import { customInstance } from '../AxiosInstance';
import type { ErrorType } from '../AxiosInstance';




export const getApiMonetizationPatterns = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<MonetizationPatternAttributesApiDTO[]>(
      {url: `/api/monetizationPatterns`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiMonetizationPatternsQueryKey = () => {
    return [`/api/monetizationPatterns`] as const;
    }

    
export const getGetApiMonetizationPatternsQueryOptions = <TData = Awaited<ReturnType<typeof getApiMonetizationPatterns>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMonetizationPatterns>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMonetizationPatternsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMonetizationPatterns>>> = ({ signal }) => getApiMonetizationPatterns(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMonetizationPatterns>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiMonetizationPatternsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMonetizationPatterns>>>
export type GetApiMonetizationPatternsQueryError = ErrorType<unknown>

export const useGetApiMonetizationPatterns = <TData = Awaited<ReturnType<typeof getApiMonetizationPatterns>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMonetizationPatterns>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiMonetizationPatternsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const postApiMonetizationPatterns = (
    monetizationPatternCreateAttributesApiDTO: MonetizationPatternCreateAttributesApiDTO,
 ) => {
      
      
      return customInstance<MonetizationPatternAttributesApiDTO>(
      {url: `/api/monetizationPatterns`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: monetizationPatternCreateAttributesApiDTO
    },
      );
    }
  


export const getPostApiMonetizationPatternsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMonetizationPatterns>>, TError,{data: MonetizationPatternCreateAttributesApiDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiMonetizationPatterns>>, TError,{data: MonetizationPatternCreateAttributesApiDTO}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiMonetizationPatterns>>, {data: MonetizationPatternCreateAttributesApiDTO}> = (props) => {
          const {data} = props ?? {};

          return  postApiMonetizationPatterns(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiMonetizationPatternsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiMonetizationPatterns>>>
    export type PostApiMonetizationPatternsMutationBody = MonetizationPatternCreateAttributesApiDTO
    export type PostApiMonetizationPatternsMutationError = ErrorType<unknown>

    export const usePostApiMonetizationPatterns = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMonetizationPatterns>>, TError,{data: MonetizationPatternCreateAttributesApiDTO}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiMonetizationPatterns>>,
        TError,
        {data: MonetizationPatternCreateAttributesApiDTO},
        TContext
      > => {

      const mutationOptions = getPostApiMonetizationPatternsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const putApiMonetizationPatternsId = (
    id: string,
    monetizationPatternCreateAttributesApiDTO: MonetizationPatternCreateAttributesApiDTO,
 ) => {
      
      
      return customInstance<MonetizationPatternAttributesApiDTO>(
      {url: `/api/monetizationPatterns/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: monetizationPatternCreateAttributesApiDTO
    },
      );
    }
  


export const getPutApiMonetizationPatternsIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiMonetizationPatternsId>>, TError,{id: string;data: MonetizationPatternCreateAttributesApiDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof putApiMonetizationPatternsId>>, TError,{id: string;data: MonetizationPatternCreateAttributesApiDTO}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiMonetizationPatternsId>>, {id: string;data: MonetizationPatternCreateAttributesApiDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiMonetizationPatternsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiMonetizationPatternsIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiMonetizationPatternsId>>>
    export type PutApiMonetizationPatternsIdMutationBody = MonetizationPatternCreateAttributesApiDTO
    export type PutApiMonetizationPatternsIdMutationError = ErrorType<unknown>

    export const usePutApiMonetizationPatternsId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiMonetizationPatternsId>>, TError,{id: string;data: MonetizationPatternCreateAttributesApiDTO}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof putApiMonetizationPatternsId>>,
        TError,
        {id: string;data: MonetizationPatternCreateAttributesApiDTO},
        TContext
      > => {

      const mutationOptions = getPutApiMonetizationPatternsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteApiMonetizationPatternsId = (
    id: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/monetizationPatterns/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteApiMonetizationPatternsIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiMonetizationPatternsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiMonetizationPatternsId>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiMonetizationPatternsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiMonetizationPatternsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiMonetizationPatternsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiMonetizationPatternsId>>>
    
    export type DeleteApiMonetizationPatternsIdMutationError = ErrorType<unknown>

    export const useDeleteApiMonetizationPatternsId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiMonetizationPatternsId>>, TError,{id: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiMonetizationPatternsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiMonetizationPatternsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    